import useFetch from '@hooks/useFetch';
import { processCourseData } from '@api/hooks/course/utils';
import { emptyObject } from '@constants/empty';
import reduxFreeFetcher from '@api/fetchers';

const courseMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const processedCourseData = swr.data?.processed
    ? swr.data
    : processCourseData(swr.data);

  return {
    ...swr,
    data: processedCourseData
  };
};

export const getKey = (courseUID) => `v1/collection/${courseUID}/`;

const useCourseInfo = (
  courseUID,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const key = getKey(courseUID);

  const {
    data: course,
    isValidating,
    mutate: internalMutate,
    ...rest
  } = useFetch(
    key,
    {},
    {
      use: [courseMiddleware],
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  const onToggleEnroll = async (sendEmail = false, prodigyKey = null) => {
    try {
      await reduxFreeFetcher(`v2/uplus/programmes/${courseUID}/save/`, {
        requestType: 'POST',
        body: {
          enroll: !course.isEnrolled,
          send_email: sendEmail,
          prodigy_key: prodigyKey
        }
      });
      return await internalMutate();
    } catch (err) {
      return {
        error: {
          message: `Unable to ${
            !course.isEnrolled ? 'enroll' : 'un-enroll'
          }. Please try again!`
        }
      };
    }
  };

  const mutate = async () => {
    try {
      const data = await internalMutate();
      return processCourseData(data);
    } catch (err) {
      return {
        error: {
          message: 'Unable to fetch course. Please try again!'
        }
      };
    }
  };

  return {
    key,
    course: course || emptyObject,
    isValidating,
    mutate,
    ...rest,
    onToggleEnroll
  };
};

export default useCourseInfo;
